import Endpoints = require("../Endpoints");

import type { RequestHandler as RH } from "../RequestHandler";

import type {
	RESTDeleteAPICurrentUserGuildResult,
	RESTGetAPICurrentUserApplicationRoleConnectionResult,
	RESTGetAPICurrentUserConnectionsResult,
	RESTGetAPICurrentUserGuildsQuery,
	RESTGetAPICurrentUserGuildsResult,
	RESTGetAPICurrentUserResult,
	RESTGetAPIUserResult,
	RESTPatchAPICurrentUserJSONBody,
	RESTPatchAPICurrentUserResult,
	RESTPostAPICurrentUserCreateDMChannelResult,
	RESTPutAPICurrentUserApplicationRoleConnectionJSONBody,
	RESTPutAPICurrentUserApplicationRoleConnectionResult
} from "discord-api-types/v10";





class UserMethods {








	public constructor(public requestHandler: RH) {}















	public async getSelf(): Promise<RESTGetAPICurrentUserResult> {
		return this.requestHandler.request(Endpoints.USER("@me"), {}, "get", "json");
	}











	public async getUser(userId: string): Promise<RESTGetAPIUserResult> {
		return this.requestHandler.request(Endpoints.USER(userId), {}, "get", "json");
	}
















	public async updateSelf(data: RESTPatchAPICurrentUserJSONBody): Promise<RESTPatchAPICurrentUserResult> {
		return this.requestHandler.request(Endpoints.USER("@me"), {}, "patch", "json", data);
	}











	public async getGuilds(options?: RESTGetAPICurrentUserGuildsQuery): Promise<RESTGetAPICurrentUserGuildsResult> {
		return this.requestHandler.request(Endpoints.USER_GUILDS("@me"), {}, "get", "json", options);
	}











	public async leaveGuild(guildId: string): Promise<RESTDeleteAPICurrentUserGuildResult> {
		return this.requestHandler.request(Endpoints.USER_GUILD("@me", guildId), {}, "delete", "json") as RESTDeleteAPICurrentUserGuildResult;
	}















	public async createDirectMessageChannel(userId: string): Promise<RESTPostAPICurrentUserCreateDMChannelResult> {
		return this.requestHandler.request(Endpoints.USER_CHANNELS("@me"), {}, "post", "json", { recipient_id: userId });
	}

















	public async createGroupDirectMessageChannel(data: { access_tokens: Array<string>; nicks?: { [userId: string]: string } }): Promise<RESTPostAPICurrentUserCreateDMChannelResult> {
		return this.requestHandler.request(Endpoints.USER_CHANNELS("@me"), {}, "post", "json", data);
	}















	public async getConnections(): Promise<RESTGetAPICurrentUserConnectionsResult> {
		return this.requestHandler.request(Endpoints.USER_CONNECTIONS("@me"), {}, "get", "json");
	}
















	public async getApplicationRoleConnection(appId: string): Promise<RESTGetAPICurrentUserApplicationRoleConnectionResult> {
		return this.requestHandler.request(Endpoints.USER_APPLICATION_ROLE_CONNECTION("@me", appId), {}, "get", "json");
	}
















	public async updateApplicationRoleConnection(appId: string, data: RESTPutAPICurrentUserApplicationRoleConnectionJSONBody): Promise<RESTPutAPICurrentUserApplicationRoleConnectionResult> {
		return this.requestHandler.request(Endpoints.USER_APPLICATION_ROLE_CONNECTION("@me", appId), {}, "put", "json", data);
	}
}

export = UserMethods;
